import React from "react"

const withMobile = (Component) => {
  const isMobile = window.innerWidth <= 800
  return (props) => <Component {...props} isMobile={isMobile} />
}
export default withMobile
